import { List, Stack, Typography } from '@mui/material';
import { Routes } from 'enums';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Shadows } from 'theme';
import { makeStyles } from 'tss-react/mui';
import PaiListItem from '../features/ui/base-components/pai-list-item';

const SignUpSuccess: React.FC = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={classes.success}>
      <div className={classes.card}>
        <div className={classes.cardHeader}>
          <span className={classes.headerMark} />
          <Typography className={classes.headerTitle}>{t('signupsucces')}</Typography>
        </div>
        <div className={classes.content}>
          <Stack gap={2}>
            <Typography className={classes.text}>{t('signupsucces1')}</Typography>
            <List disablePadding={true}>
              <PaiListItem text={t('signupsuccesAction1')} />
              <PaiListItem text={t('signupsuccesAction2')} disablePadding={true} />
            </List>
            <Typography className={classes.text}>{t('signupsucces2')}</Typography>{' '}
            <Stack direction={'row'} justifyContent={'center'}>
              <PaiLink text={t('backToLogin')} size={'sm'} variant={'primary'} underline={'always'} action={() => navigate(Routes.SIGNIN)} />
            </Stack>
          </Stack>
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  success: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  card: {
    width: '100%',
    maxWidth: '440px',
    background: '#FFF',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: Shadows.GREY_SHADOW_LIGHTER,
    [theme.breakpoints.down('sm')]: {
      boxShadow: 'unset',
    },
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '24px 28px',
    borderBottom: '1px solid #F0F0F5',
  },
  headerMark: {
    width: '32px',
    height: '32px',
    borderRadius: '8px',
    flexShrink: 0,
    backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  },
  headerTitle: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 500,
    whiteSpace: 'pre-wrap',
  },
  content: {
    padding: '28px',
  },
  text: {
    fontSize: theme.typography.pxToRem(14),
    color: '#555',
    lineHeight: 1.6,
    whiteSpace: 'pre-wrap',
  },
}));

export default SignUpSuccess;
